<div class="container p-5 bg-success text-white m-5">
    <p>Félicitation! Inscription réussie.
        <br>
        Veuillez consulter votre adresse mail pour Finaliser votre inscription
        <br>
        <a [routerLink]="['/main']" fragment="loginBlock" (click)="gotoHashtag('loginBlock')" class="text-center" style="text-decoration: none; color: lightblue">Se connecter</a>
    </p>
</div>